import { UserType } from "interfaces";
import { UserService } from "../UserService";
import { CRUDApiService } from "./CRUDApiService";

export class UserApiService extends CRUDApiService implements UserService {
  static total = 0;

  constructor() {
    super("usuario");
  }

  async get(): Promise<{ data: UserType[] }> {
    const config = {
      method: "GET",
      url: `/?PerPage=${UserApiService.total || 10}`,
    };
    return super.makeHttpRequest(config);
  }

  async getTotal(): Promise<number> {
    const config = { method: "GET" };
    const { total } = await super.makeHttpRequest({
      ...config,
    });
    return total;
  }
}
